var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9311 4.33639C17.0428 4.22989 17.1761 4.14528 17.3232 4.08751C17.4703 4.02975 17.6282 4 17.7878 4C17.9473 4 18.1053 4.02975 18.2524 4.08751C18.3995 4.14528 18.5328 4.22989 18.6444 4.33639C19.1124 4.77842 19.119 5.49271 18.6608 5.94239L8.98479 16.6337C8.87493 16.7465 8.74161 16.8371 8.593 16.9001C8.44438 16.963 8.28359 16.9969 8.12045 16.9998C7.95732 17.0027 7.79528 16.9744 7.64424 16.9167C7.4932 16.859 7.35633 16.7731 7.24202 16.6643L1.35427 11.0877C1.1272 10.8712 1 10.5802 1 10.277C1 9.9739 1.1272 9.68285 1.35427 9.4664C1.46594 9.35989 1.59923 9.27528 1.74633 9.21752C1.89342 9.15976 2.05137 9.13001 2.21092 9.13001C2.37047 9.13001 2.52842 9.15976 2.67551 9.21752C2.82261 9.27528 2.9559 9.35989 3.06757 9.4664L8.06186 14.1972L16.8984 4.37004C16.9086 4.35822 16.9195 4.34699 16.9311 4.33639Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGray);
export default __webpack_public_path__ + "static/media/check_gray.908bc195c51ffcb3e9a00482371e5234.svg";
export { ForwardRef as ReactComponent };